<template>
  <div
    class="color-sample"
    :class="{ 'with-border': showBorder }"
    :style="{ backgroundImage, backgroundColor }"></div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  interface IProps {
    color: string;
    showBorder?: boolean;
    striped?: boolean;
  }

  const props = defineProps<IProps>();

  const backgroundImage = computed(() => {
    if (props.striped) {
      return `repeating-linear-gradient(
        45deg,
        ${props.color},
        ${props.color} 3px,
        white 3px,
        white 5px
      )`;
    }

    return 'none';
  });

  const backgroundColor = computed(() => props.color);
</script>

<style scoped lang="scss">
  .color-sample {
    width: 1.5rem;
    height: 1.5rem;
    min-width: 1.5rem;
    min-height: 1.5rem;
    &.with-border {
      border: 1px rgba(0, 0, 0, 0.5) solid;
    }
  }
</style>
